import { render } from "./Navigation.vue?vue&type=template&id=70192541&scoped=true"
import script from "./Navigation.vue?vue&type=script&lang=ts"
export * from "./Navigation.vue?vue&type=script&lang=ts"

import "./Navigation.vue?vue&type=style&index=0&id=70192541&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-70192541"

export default script